import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { AddonAction } from 'models/AddonAction';
import { FC } from 'react';

const availableValues: AddonAction[] = ['Increase', 'Decrease'];

export interface AddonActionRadioButtonsProps {
  className?: string;
  e2e: string;
  value: AddonAction;
  isDisabled?: boolean;
  onSelect?(value: AddonAction): void;
}

export const AddonActionRadioButtons: FC<AddonActionRadioButtonsProps> = ({
  className,
  e2e,
  value,
  isDisabled,
  onSelect,
}) => {
  return (
    <ButtonsGroup
      id={e2e}
      isRadio
      e2e={e2e}
      className={className}
      isDisabled={isDisabled}
      items={availableValues}
      selectedItems={value}
      onSelect={items => onSelect && onSelect(items[0])}
    />
  );
};
